import { render, staticRenderFns } from "./MarketingSitesGroup.vue?vue&type=template&id=ce660454&scoped=true"
import script from "./MarketingSitesGroup.vue?vue&type=script&lang=js"
export * from "./MarketingSitesGroup.vue?vue&type=script&lang=js"
import style0 from "./MarketingSitesGroup.vue?vue&type=style&index=0&id=ce660454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce660454",
  null
  
)

export default component.exports